var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-wrap"},[_c('ul',_vm._l((_vm.socialUrls),function(social){return _c('li',[_c('a',{attrs:{"href":social.url,"target":"_blank"}},[_c('i',{class:social.icon})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }